"use client";
import React, { useRef, useState } from "react";
import { MdEdit } from "react-icons/md";

interface UtilityUploadProps {
  onChange?: any;
  file: any;
  isLoading?: boolean;
  imageUrl?: string;
  setFile?: (value: any) => void;
}

const UtilityUpload: React.FC<UtilityUploadProps> = ({
  isLoading,
  onChange,
  file,
  imageUrl,
}) => {
  let uploadUtilityRef = useRef<any>(null);
  // const [selectedFile, setSelectedFile] = useState<File | null>(null);

  const handleButtonClick = () => {
    if (uploadUtilityRef.current) {
      uploadUtilityRef.current.value = "";
      uploadUtilityRef.current.click();
    }
  };

  return (
    <div className="border-2 border-dashed border-gray-400 rounded-md p-4 text-center">
      <input
        id="utility-upload"
        type="file"
        ref={uploadUtilityRef}
        accept="image/jpeg, application/pdf"
        onChange={(e: any) => onChange(e.target.files[0])}
        className="hidden"
      />
      {(Array.isArray(file) && file.length > 0 && file[0] instanceof File) ||
      imageUrl ? (
        <div>
          <img
            src={
              Array.isArray(file) && file.length > 0 && file[0] instanceof File
                ? URL.createObjectURL(file[0])
                : imageUrl
            }
            alt="proof of identity"
            className="h-20 w-fit"
          />
          <div
            className="flex justify-end cursor-pointer"
            onClick={handleButtonClick}
          >
            {!isLoading && <MdEdit size={25} />}
          </div>
        </div>
      ) : (
        <>
          <p className="text-gray-700 text-sm font-semibold">
            Upload of utility bill
          </p>
          <p className="text-gray-500 text-sm w-52 mx-auto">
            For maximum browser support upload in JPEGs, PDF
          </p>
          <div className="mt-4">
            <label
              htmlFor="utility-upload"
              className="px-4 py-2 text-sm bg-transparent border border-gray-400 rounded-md text-gray-700 cursor-pointer"
            >
              Upload utility bill
            </label>
          </div>
        </>
      )}
    </div>
  );
};

export default UtilityUpload;
